const animation = require("./round7.json");

module.exports = {
    loop: false,
    autoplay: false,
    animationData: animation,
    rendererSettings: {
        preserveAspectRatio: 'none'
    },
}